/**
 * Sentinel value used across CRM export flows to represent the "create a new CRM account"
 * choice (as opposed to updating an existing account referenced by its id).
 */
export const NEW_ACCOUNT_VALUE = "new_account";
